__webpack_require__.p = "https://monocle.uat.magmutual.com/";